import _Request from '../Request';

class RealBalanceService extends _Request {
  constructor() {
    super('/wallet');
  }

  getRealBalance() {
    return this.send({ method: 'get' });
  }

  enablePayingFromWallet(enablePayingFromBonusWallet: boolean) {
    return this.send({ method: 'patch', data: { enablePayingFromBonusWallet } });
  }
}

export default new RealBalanceService();
